import { makeStyles, tokens, shorthands } from "@fluentui/react-components";

export const useButtonStyle = makeStyles({
	squareDefaultButton: {
		minWidth: "50px",
		height: "50px",
		...shorthands.borderColor(tokens.colorNeutralBackground5),

		"&:hover": {
			...shorthands.borderColor(tokens.colorNeutralBackground5),
		},
	},
	tooltipContent: {
		zIndex: "6"
	}
});
